import { jsx as _jsx } from "react/jsx-runtime";
import { useUncontrolledProp } from 'uncontrollable';
import { TabsContext } from '../../context';
import { Tab as TabComponent } from '../Tab';
import { TabBar as TabBarComponent } from '../TabBar';
import { TabContent as TabContentComponent } from '../TabContent';
export function Tabs({ children, onChange, value, defaultValue }) {
    const [selectedTab, setSelectedTab] = useUncontrolledProp(value, defaultValue, onChange);
    return (_jsx(TabsContext.Provider, { value: {
            selectedTab,
            setSelectedTab,
        }, children: children }));
}
(function (Tabs) {
    Tabs.Tab = TabComponent;
    Tabs.TabBar = TabBarComponent;
    Tabs.TabContent = TabContentComponent;
})(Tabs || (Tabs = {}));
